import React, { useRef, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import {
    Avatar,
    Button,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import ButtonAction from '../Button.js/SaveButton';
import { useTranslation } from 'react-i18next';
import { Stack } from 'react-bootstrap';
import Iconify from '../iconify/Iconify';
import ChangePassModal from './ChangePassModal';
import { toPng } from 'html-to-image';
import QRCode from 'react-qr-code';
import NumberInput from '../Input/NumberInput';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const ImageQRCodeModal = ({
    visible = false,
    setVisible,
    valueImageQR,
    valueNameDevice,
    valueCodeDevice,
    isRequestDeice = false,
}) => {
    const { t } = useTranslation();
    const qrRef = useRef(null); // Ref cho thẻ QR code
    const theme = useTheme();
    const [visibleInputNumbers, setVisibleInputNumbers] = useState(false);
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    // const numberOfRows = useRef(10)
    const [quantity, setQuantity] = useState(1);
    const quantityRef = useRef(null);
    const [loading, setLoading] = useState(false);

    // const generateAndDownloadQR = (url) => {
    //     console.log('Generating', url);
    //     // Tạo mã QR từ URL được cung cấp
    //     const qrCodeDataUrl = QRCode.toDataURL(url);

    //     // Tạo một thẻ <a> để tải xuống mã QR
    //     const downloadLink = document.createElement('a');
    //     downloadLink.href = qrCodeDataUrl;
    //     downloadLink.download = 'qr-code.png'; // Tên tệp tải xuống

    //     // Kích hoạt sự kiện nhấp chuột để tải xuống
    //     downloadLink.click();
    // }

    const printQRCode = () => {
        const element = document.getElementById('qrCode');
        if (element) {
            var windowContent = '<!DOCTYPE html>';
            windowContent += '<html>';
            windowContent += '<head><title>Print QR CODE</title></head>';
            windowContent += '<body>';
            windowContent += element.innerHTML;
            windowContent += '</body>';
            windowContent += '</html>';

            var printWindow = window.open('', '_blank');
            printWindow.document.open();
            printWindow.document.write(windowContent);
            printWindow.document.close();
            printWindow.print();
            // setVisible(false);
            // printWindow.close();
        } else {
            throw new Error('Element with id qrCode not found.');
        }
    };

    const rowsToPrint = Array.from({ length: quantity }, (_, index) => (
        <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell
                component="th"
                scope="row"
                style={{
                    border: '1px solid #dddddd',
                    padding: '4px',
                    textAlign: 'center',
                    width: '50px',
                }}
            >
                {valueImageQR && (
                    <QRCode
                        size={256}
                        style={{ height: 'auto', maxWidth: '25%', width: '25%' }}
                        value={valueImageQR}
                        viewBox={`0 0 256 256`}
                    />
                )}
            </TableCell>
            <TableCell
                style={{
                    border: '1px solid #dddddd',
                    padding: '4px',
                    textAlign: 'center',
                    width: '100px',
                }}
            >
                <Stack display={'flex'} flexDirection={'row'}>
                    <Grid container spacing={2}>
                        {!isRequestDeice ? (
                            <>
                                <Grid item xl={12} md={6} sm={6} style={{ width: '100%', textAlign: 'left' }}>
                                    <Typography variant="subtitle3" noWrap sx={{ fontWeight: '600' }}>
                                        {t('name_device')}: {valueNameDevice}
                                    </Typography>
                                </Grid>
                                <Grid item xl={12} md={6} sm={6} style={{ width: '100%', textAlign: 'left' }}>
                                    <Typography variant="subtitle3" noWrap>
                                        {t('code_device')}: {valueCodeDevice}
                                    </Typography>
                                </Grid>
                            </>
                        ) : (
                            <Grid item xl={12} md={6} sm={6} style={{ width: '100%', textAlign: 'left' }}>
                                <Typography variant="subtitle3" noWrap sx={{ fontWeight: '600' }}>
                                    {t('code_request_device')}: {valueCodeDevice}
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                </Stack>
            </TableCell>
        </TableRow>
    ));
    // Hàm xử lý sự kiện khi người dùng nhấp vào nút tải xuống
    const handleDownload = () => {
        const qrCodeContainer = document.getElementById('qr-code-container');

        toPng(qrCodeContainer)
            .then(function (dataUrl) {
                const link = document.createElement('a');
                link.download = valueImageQR + '-qrcode.png';
                link.href = dataUrl;
                link.click();
            })
            .catch(function (error) {
                console.error('Error:', error);
            });
    };

    return (
        <>
            <BootstrapDialog
                fullScreen={fullScreen}
                open={visible}
                onClose={() => setVisible(!visible)}
                aria-labelledby="customized-dialog-title"
                fullWidth
                maxWidth={'sm'}
            >
                {/* <ChangePassModal visible={visibleChange} setVisible={setVisibleChange} /> */}
                <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setVisible(!visible)}>
                    {t('qr_code_device') + valueNameDevice}
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Stack spacing={0.5} sx={{ p: 2 }}>
                        <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            flexWrap={'wrap'}
                            spacing={2}
                        >
                            <div style={{ height: 'auto', margin: '0 auto', maxWidth: '40%', width: '100%' }}>
                                <div className="" id="qr-code-container">
                                    {
                                        valueImageQR && 
                                        <QRCode
                                            size={256}
                                            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                                            value={valueImageQR}
                                            ref={qrRef}
                                            viewBox={`0 0 256 256`}
                                        />
                                    }
                                    
                                </div>
                            </div>
                        </Stack>
                        <Stack
                            direction="row"
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop: '8px',
                            }}
                        >
                            <Button
                                onClick={handleDownload}
                                startIcon={<Iconify icon="tabler:download" />}
                                variant="outlined"
                                style={{ marginRight: '8px' }}
                            >
                                {t('download')}
                            </Button>
                            <Button
                                onClick={() => {
                                    setVisibleInputNumbers(true);
                                }}
                                startIcon={<Iconify icon="ic:outline-local-printshop" />}
                                variant="outlined"
                            >
                                {t('print')}
                            </Button>
                            {/* <Button
                                onClick={() => {
                                    printQRCode();
                                    // setVisibleInputNumbers(false);
                                    // setQuantity(0);
                                }}
                                startIcon={<Iconify icon="material-symbols:check-circle" />}
                                color="primary"
                                variant='outlined'
                                size='small'
                            >
                                Print QR Code
                            </Button> */}
                        </Stack>
                    </Stack>

                    <Stack id="qrCode" style={{ display: 'None' }}>
                        <TableContainer component={Paper}>
                            <Table
                                sx={{ minWidth: 650 }}
                                aria-label="simple table"
                                style={{ borderCollapse: 'separate', borderSpacing: '0 10px', minWidth: '100%' }}
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell>QR Code</TableCell>
                                        <TableCell align="right">{t('info')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>{rowsToPrint}</TableBody>
                            </Table>
                        </TableContainer>
                    </Stack>
                </DialogContent>
                <DialogActions style={{ padding: '12px 16px' }}>
                    {/* <ButtonAction onClick={() => setVisible(!visible)} type={'cancel'} title={t('cancel')} /> */}
                    {/* <ButtonAction type={'change'} onClick={() => setVisibleChange(true)} /> */}
                </DialogActions>
            </BootstrapDialog>

            {/* Modal nhập số lượng cho bản in */}
            <BootstrapDialog
                open={visibleInputNumbers}
                aria-labelledby="customized-dialog-title"
                PaperProps={{ component: 'div' }}
            >
                <BootstrapDialogTitle
                    onClose={() => {
                        setVisibleInputNumbers(!visibleInputNumbers);
                        setQuantity(1);
                    }}
                    id="customized-dialog-title"
                    style={{ marginRight: '40px' }}
                >
                    {t('input_quantity_print')}
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid item style={{ width: '100%' }} xl={12} md={12} sm={12}>
                            <NumberInput
                                label={t('quantity_category')}
                                valueChange={quantity}
                                size="medium"
                                autoFocus
                                // required
                                // onEnterPress={handleClick}
                                ref={quantityRef}
                                getValue={setQuantity}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ padding: '12px 16px' }}>
                    <ButtonAction
                        onClick={() => {
                            setVisibleInputNumbers(!visibleInputNumbers);
                            setQuantity(1);
                        }}
                        type={'cancel'}
                        title={t('cancel')}
                    />
                    <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap={'wrap'}>
                        <Button
                            onClick={() => {
                                printQRCode();
                                setVisibleInputNumbers(false);
                                setQuantity(1);
                            }}
                            startIcon={<Iconify icon="material-symbols:check-circle" />}
                            color="primary"
                            variant="outlined"
                            size="small"
                        >
                            {t('comfirm')}
                        </Button>
                    </Stack>
                </DialogActions>
            </BootstrapDialog>
        </>
    );
};

export default ImageQRCodeModal;
